import { render, staticRenderFns } from "./event-details.vue?vue&type=template&id=3809df3e&"
import script from "./event-details.vue?vue&type=script&lang=js&"
export * from "./event-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports